import { addAminBonusApi, getAllUserByIdApi, getUserApi, getYoutubeUserApi, updateUserApi, blockUserApi, getUserWalletApi, exportUsersApi, updateRestrictApi } from "../components/constant/Api";
import { myApi } from "./api";

export const userApi = myApi.injectEndpoints({
  endpoints: (builder) => ({

    getUser: builder.query({
      query: (params) => {
        const queryString = params ? "?" + new URLSearchParams(params).toString() : "";
        return {
          url: getUserApi + queryString,
          method: "GET",
        };
      },
      transformResponse: (response, meta, arg) => {
        return response.status ? response : { data: [], total: 0 };
      },
      providesTags: (_) => ["user"],
    }),
    setAddAminBonus: builder.mutation({
      query: (post) => ({
        url: addAminBonusApi,
        method: "POST",
        body: post
      }),
      invalidatesTags: (_) => ["transaction"],
    }),
    getYoutubeUSer: builder.query({
      query: (post) => ({
        url: getYoutubeUserApi,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? [] : [];
      },
      providesTags: (_) => ["user"],
    }),
    getAllUserById: builder.mutation({
      query: (post) => ({
        url: getAllUserByIdApi,
        method: "POST",
        body: post
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? [] : [];
      },
      providesTags: (_) => ["user"],
    }),
    updateUser: builder.mutation({
      query: (post) => ({
        url: updateUserApi,
        method: "POST",
        body: post
      }),
      invalidatesTags: (_) => ["user"],
    }),
    blockUser: builder.mutation({
      query: (post) => ({
        url: blockUserApi,
        method: "POST",
        body: post
      }),
      invalidatesTags: (_) => ["user"],
    }),
    getUserWallet: builder.mutation({
      query: (post) => ({
        url: getUserWalletApi,
        method: "POST",
        body: post
      }),
    }),
    exportUsers: builder.mutation({
      query: () => ({
        url: exportUsersApi,
        method: "GET"
      }),
    }),
    updateRestrict: builder.mutation({
      query: (post) => ({
        url: updateRestrictApi,
        method: "POST",
        body: post
      }),
      invalidatesTags: (_) => ["user"],
    }),

  }),
});

export const { useGetUserQuery, useSetAddAminBonusMutation, useGetYoutubeUSerQuery, useGetAllUserByIdMutation, useUpdateUserMutation, useBlockUserMutation, useGetUserWalletMutation, useExportUsersMutation, useUpdateRestrictMutation } = userApi;